import { MendableInPlace } from '@mendable/search';
import UseCase from './interface';
import { ArrowDown, FastForward, Lightbulb, Ticket } from 'lucide-react';
// export default string

export const documentationSupportUseCase: UseCase = {
  cta: 'Reduce incoming support tickets by up to 30%',
  description:
    'Minimize support overhead, directly cutting operational costs with an AI you can trust. Get started building AI Chat Search in minutes instead of weeks.',
  ctaComponent: undefined,
  companyHighlight: {
    title: 'View how 0x uses Mendable',
    icon: '/0xlogo.png',
    link: 'https://0x.org/docs'
  },
  title: 'Documentation - Mendable AI',
  url: '/usecases/documentation',
  valueProps: {
    title: 'Why use Mendable in your docs?',
    description:
      'Mendable is the easiest way to decrease user activation time. Our AI is trained on your data and can instantly answer any question your customers have when onboarding or just using your product.',
    sectionProps: [
      {
        title: 'Key Benefits',
        individualProps: [
          {
            title: 'Reduce tickets',
            description:
              'Minimize support overhead, directly cutting operational costs.',
            icon: <FastForward className="w-4" />
          },
          {
            title: 'Reduced Churn',
            description:
              'Enhance user experience, retaining more satisfied customers.',
            icon: <Ticket className="w-4" />
          },
          {
            title: 'Decrease Time to Implement',
            description: 'Speed up onboarding, driving faster ROI.',
            icon: <ArrowDown className="w-4" />
          }
        ]
      }
    ]
  }
};

export const customerSupportUseCase: UseCase = {
  cta: 'Instantly solve 50% of your customer support tickets',
  description:
    'Reduce customer support volume with an AI you can trust. Get started building AI Chat Search in minutes instead of weeks.',
  ctaComponent: undefined,
  companyHighlight: {
    title: 'View how Worldline uses Mendable',
    icon: '/worldline_logo_white.png',
    link: 'https://worldline.com/'
  },
  title: 'Customer Support - Mendable AI',
  url: '/usecases/customersupport',
  valueProps: {
    title: 'Why use Mendable for customer support?',
    description:
      'Mendable is the easiest way to reduce customer support volume. Our AI is trained on your data and can instantly answer any questions your customers have.',
    sectionProps: [
      {
        title: 'Key Benefits',
        individualProps: [
          {
            title: 'Faster Ticket Resolution',
            description:
              'Streamline support, reduce overheads, and save on operational costs.',
            icon: <FastForward className="w-4" />
          },
          {
            title: 'Fewer Tickets Incoming',
            description:
              'Minimize agent workload, ensuring optimal resource allocation and boosting ROI.',
            icon: <Ticket className="w-4" />
          },
          {
            title: 'Reduced Churn Rate',
            description:
              'Retain more customers, translating to steady revenue and long-term growth',
            icon: <ArrowDown className="w-4" />
          }
        ]
      }
    ]
  }
};

export const productCopilotUseCase: UseCase = {
  cta: 'Speed up product adoption times by 20%',
  description:
    'Streamline onboarding, cutting down on support costs and quickening adoption with an AI you can trust. Get started building AI Chat Search in minutes instead of weeks.',
  ctaComponent: undefined,
  companyHighlight: {
    title: 'View how Spectrocloud uses Mendable',
    icon: '/spectrocloud-white.png',
    link: 'https://docs.spectrocloud.com/'
  },
  title: 'Product Copilot - Mendable AI',
  url: '/usecases/productcopilot',
  valueProps: {
    title: 'Why use Mendable for product copilot?',
    description:
      'Mendable boosts user self-reliance, slashing support inquiries and expenses. Our AI is trained on your data and can instantly answer any question your customers have.',
    sectionProps: [
      {
        title: 'Key Benefits',
        individualProps: [
          {
            title: 'Context Aware',
            description:
              'Mendable understands the current context of where the user is in the product and can provide personalized answers.',
            icon: <FastForward className="w-4" />
          },
          {
            title: 'Real-time Assistance',
            description:
              'Offer in-app solutions, diminishing user frustrations and upping engagement.',
            icon: <Ticket className="w-4" />
          },
          {
            title: 'Empower Users, Lower Costs',
            description:
              'Boost user self-reliance, slashing support inquiries and expenses.',
            icon: <ArrowDown className="w-4" />
          }
        ]
      }
    ]
  }
};

export const salesCopilotUseCase: UseCase = {
  cta: 'Increase conversion by giving sales teams instant technical knowledge',
  description:
    'Reduce wait-times, streamline engagement, and amplify ROI with an AI you can trust. Get started in minutes.',
  ctaComponent: undefined,
  companyHighlight: {
    title: 'View how Nylas uses Mendable',
    icon: '/nylas.png',
    link: 'https://nylas.com/'
  },
  title: 'Sales Enablement - Mendable AI',
  url: '/usecases/salescopilot',
  valueProps: {
    title: 'Why use Mendable for Sales Enablement?',
    description:
      'Mendable improves sales operations by giving reps instant technical know-how, allowing then to better understand customer pain point and win trust faster. Our AI is trained on your data and can instantly answer any question your customers have integrate.',
    sectionProps: [
      {
        title: 'Key Benefits',
        individualProps: [
          {
            title: 'Accelerate Sales Cycle',
            description:
              'Reduce wait-times, streamline engagement, and amplify ROI.',
            icon: <FastForward className="w-4" />
          },
          {
            title: 'Boost Conversions',
            description:
              'Enhance user interactions, translating to more successful deals.',
            icon: <Ticket className="w-4" />
          },
          {
            title: "Sales' AI Sidekick",
            description:
              'Equip teams with instant technical know-how, winning trust faster.',
            icon: <Lightbulb className="w-4" />
          }
        ]
      }
    ]
  }
};

//
export default function noexport() {
  return <div>noexport</div>;
}
